import { render } from "./MenuArea.vue?vue&type=template&id=aad4c91e&scoped=true"
import script from "./MenuArea.vue?vue&type=script&lang=js"
export * from "./MenuArea.vue?vue&type=script&lang=js"

import "./MenuArea.vue?vue&type=style&index=0&id=aad4c91e&scoped=true&lang=css"

import exportComponent from "/home/hkohashi/webinar-master-php83/frontend-system/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aad4c91e"]])

export default __exports__